import { Component } from '@angular/core';

import { CalService } from 'src/app/auth/cal.service';

@Component({
  selector: 'app-acd-define',
  templateUrl: './acd-define.component.html',
  styleUrl: './acd-define.component.scss'
})
export class AcdDefineComponent {
  token = ""
  constructor(
    private cal: CalService,) {
    this.cal.getAADToken().then((accessToken) => {
      this.token = accessToken as string;
    });
  }
 
}

